// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LineHeightOutlinedSvg from "@ant-design/icons-svg/es/asn/LineHeightOutlined";
import AntdIcon from '../components/AntdIcon';

var LineHeightOutlined = function LineHeightOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: LineHeightOutlinedSvg
  }));
};

LineHeightOutlined.displayName = 'LineHeightOutlined';
export default React.forwardRef(LineHeightOutlined);